@if (gymImages.images) {
  <div class="changelog-image-container">
    @for (image of gymImages.images; track image; let i = $index) {
      <div
        [ngClass]="image.error ? 'changelog-image-error' : ''">
        <img
          [src]="image.imageURL"
          class="changelog-image"
          alt="{{ image.imageId }} might have been deleted recently."
          (error)="onImageLoadError(i)" />
      </div>
    }
  </div>
}

@if (gymImages.deletedImages && gymImages.deletedImages.length > 0) {
  <div
    class="changelog-image-container">
    <div class="changelog-image-error">
      +{{ gymImages.deletedImages.length }} images deleted
    </div>
  </div>
}
